import BaseModel from "@/models/BaseModel";

export default function({ $axios, $config }) {
  // Add Cloudflare Access headers for server-side requests (for local dev against dev-api-master)
  if (process.server && $config.cfAccess?.clientId && $config.cfAccess?.clientSecret) {
    $axios.onRequest((config) => {
      config.headers["CF-Access-Client-Id"] = $config.cfAccess.clientId;
      config.headers["CF-Access-Client-Secret"] = $config.cfAccess.clientSecret;
    });
  }

  BaseModel.setAxios($axios);
}
